export class EquipmentDiagnosis {
  public profile;
  public profileName;
  public configGroup;
  public configStatus;
  public firmwareVersion;
  public firmwareStatus;
  public calampAccumulatorsConfigured;
  public isRunning;
  public phoneNumber;
  public status;
  public equipmentData;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/equipment-diagnosis.ts